import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Application } from 'src/app/models/application.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { MatButton, MatAnchor, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { CompanyProductPageIdentityComponent } from '../company-product-page-identity/company-product-page-identity.component';

@Component({
  selector: 'app-company-product-applications',
  templateUrl: './company-product-applications.component.html',
  styleUrls: ['./company-product-applications.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatButton,
    RouterLink,
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatAnchor,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatChipsModule,
    CompanyProductPageIdentityComponent,
  ],
})
export class CompanyProductApplicationsComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);
  private api = inject(ApiService);
  permissions = inject(PermissionsService);

  protected readonly page_title = inject(ActivatedRoute).snapshot.title;

  displayedColumns: string[] = ['name', 'git', 'github_status', 'actions'];
  dataSource: MatTableDataSource<Application> = new MatTableDataSource();

  company_product_id: string = null as any;

  ngOnInit(): void {
    this.initCompanyProductIdParam();
    this.fetchApplications();
  }

  canManage(): boolean {
    return (
      this.permissions.validateDepartment(['direction']) ||
      this.permissions.isBisualProductionTeamInCompanyProductWithRole(this.company_product_id, 'tech-lead') ||
      this.permissions.isBisualProductionTeamInCompanyProductWithRole(this.company_product_id, 'product-manager')
    );
  }

  delete(app: Application) {
    this.api.deleteApplication(app.id.toString()).subscribe(data => {
      this.fetchApplications();
    });
  }

  private initCompanyProductIdParam() {
    this.company_product_id = this.activatedRoute.snapshot.parent?.parent?.paramMap.get('id') as string;
  }

  private fetchApplications() {
    this.api
      .getCompanyProductApplications(this.company_product_id, {
        append: 'github_token_set',
      })
      .subscribe(data => {
        this.dataSource.data = data;
      });
  }
}
